<template>
    <div class="attribute">
        <template v-if="!message">
            <AttributeLayout
                ref="attribute"
                :tree="tree"
                :recommend="attrData.categoryType === '3'"
                :is-show-custom="isShowCustom"
                :is-show-custom-attribute="isShowCustomAttribute"
            />
            <div v-if="isShowCustom" style="margin-left: 10px">
                <el-button size="mini" type="text" @click="addProductAttr">+ 添加产品属性</el-button>
            </div>
        </template>
        <div v-else class="message orange">
            <i class="el-icon-loading" style="margin-right: 5px; font-size: 20px"></i>{{ message }}
        </div>
    </div>
</template>

<script>
let options = {};
let callBack;
let callBack2;
import AttributeLayout from './components/attributeLayout';
export default {
    components: {
        AttributeLayout,
    },
    props: {
        isShowCustom: {
            type: Boolean,
            default: false,
        },
        isShowCustomAttribute: {
            type: Boolean,
            default: false,
        },
        // attrData:{
        //       type:Object,
        //       required: false
        //     }
    },
    data() {
        return {
            tree: [],
            message: '请先选择行业类目',
            attrData: {
                categoryType: null,
                LevelTitle: '',
                ClassifyId: -1,
                AttrVals: [],
                initAttrVals: [],
            },
        };
    },
    computed: {},
    beforeCreate() {},
    created() {},
    mounted() {},
    methods: {
        getData() {
            return options;
        },
        setOptions(opt) {
            this.tree = opt.tree;
            options = JSON.parse(JSON.stringify(opt.options));
        },
        checkSameName() {
            var isCustomNmae = [];
            var isSameName = false; // 验证isCustomNmae是否已经有重复的了
            var tips = [];
            if (options.AttrVals != undefined) {
                for (var i = options.AttrVals.length - 1; i > 0; i--) {
                    if (!options.AttrVals[i].isCustom || options.AttrVals[i].isCustom == undefined) {
                        // 非自定义的类目属性排除
                        break;
                    }
                    const findIndex = isCustomNmae.findIndex((item) => {
                        return item == options.AttrVals[i].name;
                    });
                    if (findIndex > -1) {
                        // 要验证的name已经在数组中，说明自定义的属性中 都已经重复了 如添加了2个自定义属性 name都叫 小志
                        isSameName = true;
                        tips.push('自定义"产品属性->' + options.AttrVals[i].name + '"已经存在');
                        break;
                    }
                    if (options.AttrVals[i].name != '') {
                        // 不为空
                        isCustomNmae.push(options.AttrVals[i].name);
                    }
                }
            }
            if (isSameName) {
                return tips;
            }
            for (var x = 0; x < isCustomNmae.length; x++) {
                for (var j = 0; j < options.AttrVals.length; j++) {
                    if (!options.AttrVals[j].isCustom || options.AttrVals[j].isCustom == undefined) {
                        // 非自定义的类目属性
                        if (options.AttrVals[j].name == isCustomNmae[x]) {
                            tips.push('自定义"产品属性->' + options.AttrVals[j].name + '"已经存在');
                            break;
                        }
                    }
                }
            }
            return tips;
        },
        validate() {
            // 手动验证
            const tree = this.tree;
            const error = [];
            let sameNameError = [];
            if (this.isShowCustom || this.isShowCustomAttribute) {
                sameNameError = this.checkSameName();
            }
            var getErrorF = function (tree) {
                for (var i = 0; i < tree.length; i++) {
                    if (tree[i].isNeeded == 'Y' && (tree[i].value == '' || tree[i].value == [])) {
                        if (tree[i].inputType == 0) {
                            error.push('请填写"产品属性->' + tree[i].name + '"');
                        } else {
                            error.push('请选择"产品属性->' + tree[i].name + '"');
                        }
                    }
                    if (tree[i].subtree.length > 0) {
                        getErrorF(tree[i].subtree);
                    }
                }
            };
            getErrorF(tree);
            Array.prototype.push.apply(error, sameNameError);
            return error;
        },
        validateRecommend() {
            // 验证推荐属性
            // categoryType===3且recommendAttr的属性如果为空就提醒
            const tree = this.tree;
            const error = [];
            if (this.attrData.categoryType !== '3') {
                return error;
            }
            // 手动验证

            var getErrorF = function (tree) {
                for (var i = 0; i < tree.length; i++) {
                    if (tree[i].recommendAttr && (tree[i].value == '' || tree[i].value == [])) {
                        if (tree[i].inputType == 0) {
                            error.push('请填写"推荐产品属性->' + tree[i].name + '"');
                        } else {
                            error.push('请选择"推荐产品属性->' + tree[i].name + '"');
                        }
                    }
                    if (tree[i].subtree.length > 0) {
                        getErrorF(tree[i].subtree);
                    }
                }
            };
            getErrorF(tree);
            return error;
        },
        addTxtNameInput: function (el) {
            // 添加属性 修改属性事件
            for (var i = 0; i < options.AttrVals.length; i++) {
                if (options.AttrVals[i].fid == el.fid) {
                    options.AttrVals[i].name = el.name;
                    break;
                }
            }
        },
        deleteAttr(el) {
            // 删除自定义属性
            var fid = el.fid;
            var name = el.name;
            for (var i = options.AttrVals.length - 1; i > 0; i--) {
                if (options.AttrVals[i].fid == fid && options.AttrVals[i].name == name) {
                    options.AttrVals.splice(i, 1);
                    break;
                }
            }
            for (var j = this.tree.length - 1; j > 0; j--) {
                if (this.tree[j].fid == fid && this.tree[j].name == name) {
                    this.tree.splice(j, 1);
                    break;
                }
            }
        },
        addProductAttr() {
            // 添加自定义类目属性
            const addAttr = {
                defaultVaule: '',
                defaultVid: '',
                featureIdValues: [],
                featureType: '0;',
                fid: '',
                fieldType: 'string',
                inputType: 0,
                isNeeded: 'N',
                isSpecAttr: false,
                isSpecPicAttr: false,
                name: '',
                pathValues: '',
                subtree: [],
                unit: '',
                value: '',
                vid: '',
                isCustom: true,
            };
            var maxAddlen = 0;
            for (var i = 0; i < options.AttrVals.length; i++) {
                if (options.AttrVals[i].isCustom) {
                    maxAddlen = maxAddlen + 1;
                }
            }
            addAttr.fid = 'divFid' + parseInt(Math.random() * 1000000);
            if (maxAddlen >= 3) {
                this.$message({
                    message: '最多支持添加3个自定义属性！',
                    type: 'waring',
                });
                return;
            }
            options.AttrVals.push(JSON.parse(JSON.stringify(addAttr)));
            this.tree.push(JSON.parse(JSON.stringify(addAttr)));
        },
        selectCallBack(el) {
            // 下拉选择完成之后回调 把选中的选项透传出去 验证规格用的
            const _pathValues = [];
            if (el.pathValues == '') {
                // 一级下拉值
                _pathValues.push(el.fid + ':' + el.vid);
            } else if (el.pathValues.indexOf('>') <= -1) {
                // 二级下拉值
                _pathValues.push(el.pathValues + '>' + el.fid + ':' + el.vid);
            }
            callBack && callBack(_pathValues, this.tree);
        },
        getSubtree(el, isGet) {
            // 获取子菜单
            var _pathValues = el.fid + ':' + el.vid; // 二级选项标识符
            var _tPathValues = el.pathValues + '>' + _pathValues; // 三级选项标识符
            var array = [];
            var subArray = [];
            // 拆除树形结构
            if (el.subtree.length > 0) {
                // 有二级菜单
                for (var i = 0; i < el.subtree.length; i++) {
                    if (el.subtree[i].subtree.length > 0) {
                        // 有三级菜单
                        for (var j = 0; j < el.subtree[i].subtree.length; j++) {
                            el.subtree[i].subtree[j].value = '';
                            el.subtree[i].subtree[j].vid = '';
                            this.setValue(el.subtree[i].subtree[j]);
                        }
                    }
                    el.subtree[i].value = el.subtree[i].inputType == 2 || el.subtree[i].inputType == 4 ? [] : '';
                    el.subtree[i].vid = el.subtree[i].inputType == 2 || el.subtree[i].inputType == 4 ? [] : '';
                    el.subtree[i].subtree = [];
                    this.setValue(el.subtree[i]);
                }
            }
            el.subtree = [];
            let theSameFid; // 当切换下拉框的时候 如果有子集需要把所有的自己都清空掉 包括一样的fid的下级
            for (let i = 0; i < options.AttrVals.length; i++) {
                // 创建树形结构
                if (_pathValues == options.AttrVals[i].pathValues) {
                    theSameFid = options.AttrVals[i].fid;
                    // 二级选项
                    options.AttrVals[i].value =
                        options.AttrVals[i].inputType == 2 || options.AttrVals[i].inputType == 4 ? [] : '';
                    options.AttrVals[i].vid =
                        options.AttrVals[i].inputType == 2 || options.AttrVals[i].inputType == 4 ? [] : '';
                    options.AttrVals[i].subtree = [];
                    array.push(Object.assign({}, options.AttrVals[i]));
                    el.subtree = array;
                }
                if (_tPathValues == options.AttrVals[i].pathValues) {
                    theSameFid = options.AttrVals[i].fid;
                    // 三级选项
                    options.AttrVals[i].value =
                        options.AttrVals[i].inputType == 2 || options.AttrVals[i].inputType == 4 ? [] : '';
                    options.AttrVals[i].vid =
                        options.AttrVals[i].inputType == 2 || options.AttrVals[i].inputType == 4 ? [] : '';
                    options.AttrVals[i].subtree = [];
                    subArray.push(Object.assign({}, options.AttrVals[i]));
                    el.subtree = subArray;
                }
            }

            if (theSameFid) {
                options.AttrVals.forEach((v) => {
                    if (v.fid === theSameFid) {
                        v.value = v.inputType == 2 || v.inputType == 4 ? [] : '';
                        v.vid = v.inputType == 2 || v.inputType == 4 ? [] : '';
                    }
                });
            }
            if (isGet) {
                this.tree = this.tree.map((item) => {
                    if (item.fid == el.fid) {
                        item = JSON.parse(JSON.stringify(el));
                    }
                    return item;
                });
                if (isGet == 'get') {
                    this.$emit('getTree', this.tree);
                }
            }
        },
        // 构造树形结构
        strTree(array) {
            var _array = [];
            array.map((item) => {
                // 兼容旧的属性vid 是字符串的问题
                if (item.inputType != 2 && item.inputType != 4 && item.vid != '') {
                    item.vid = parseInt(item.vid);
                } else if ((item.inputType == 2 || item.inputType == 4) && item.vid != '') {
                    const vid = [];
                    for (let i = 0; i < item.vid.length; i++) {
                        vid.push(parseInt(item.vid[i]));
                    }
                    item.vid = vid;
                }
                if ((item.inputType == 2 || item.inputType == 4) && item.value == '') {
                    item.value = [];
                    item.vid = [];
                }
                if (item.subtree.length > 0 && item.subtree[0] == '') {
                    item.subtree = [];
                }
                return item;
            });
            Array.prototype.push.apply(_array, array); // 合并数组
            // 构造三级树形
            for (var z = 0; z < _array.length; z++) {
                if (_array[z].pathValues != '') {
                    // 排除掉第一级的对象
                    var _tPathValues = _array[z].pathValues;
                    if (_tPathValues.split('>').length > 1) {
                        // 三级菜单的格式是xxx:xxx>xxx:xxx
                        // var _tFid = _tPathValues.split(">")[0].split(":")[0];
                        var _sFid = _tPathValues.split('>')[1].split(':')[0];
                        var _sVid = _tPathValues.split('>')[1].split(':')[1];
                        for (var g = 0; g < _array.length; g++) {
                            if (
                                _array[g].fid == _sFid &&
                                _array[g].vid == _sVid &&
                                _tPathValues.split('>')[0] == _array[g].pathValues
                            ) {
                                _array[g].subtree.push(_array[z]);
                            }
                        }
                    }
                }
            }
            // 构造二级树形
            for (var i = 0; i < _array.length; i++) {
                if (_array[i].pathValues == '') {
                    // 为空才是一级对象
                    var _fid = _array[i].fid;
                    var _value = _array[i].vid;
                    var _pathValues = _fid + ':' + _value;
                    for (var j = 0; j < _array.length; j++) {
                        if (_array[j] != '') {
                            // 不为空才是子集对象
                            if (_array[j].pathValues == _pathValues) {
                                // 该对象的二级菜单 二级菜单格式是xxx:xxx
                                _array[i].subtree.push(_array[j]);
                            }
                        }
                    }
                }
            }
            var errorArray = [];
            for (let j = 0; j < _array.length; j++) {
                if (_array[j].pathValues != '') {
                    errorArray.push(j);
                }
            }
            for (var x = errorArray.length - 1; x >= 0; x--) {
                // 删除多余节点
                _array.splice(errorArray[x], 1);
            }
            const currArray = JSON.parse(JSON.stringify(_array));
            return currArray;
        },
        setValue(el) {
            // 设置值
            for (let i = 0; i < options.AttrVals.length; i++) {
                if (options.AttrVals[i].fid == el.fid && options.AttrVals[i].pathValues == el.pathValues) {
                    options.AttrVals[i].vid = el.vid;
                    options.AttrVals[i].value = el.value;
                }
            }
            this.$emit('change');
        },
        init() {
            this.tree = [];
            this.message = '正在加载数据';
            options = {};
            callBack = undefined;
        },
        initAttr() {
            const initData = JSON.parse(JSON.stringify(this.attrData));
            options.LevelTitle = initData.LevelTitle;
            options.ClassifyId = initData.ClassifyId;
            options.AttrVals = initData.AttrVals;
            options.categoryType = initData.categoryType;
            this.tree = this.strTree(this.attrData.AttrVals);
            this.filterPathValues(this.attrData.AttrVals);
            this.$emit('getTree', this.tree);
            this.message = '';
        },
        checkParentAttr(attrVals, el) {
            // 验证属性是否相同
            el = JSON.parse(JSON.stringify(el));

            let parentFid;
            let parentVid;
            let isPase = true;
            if (el.pathValues != '' && !el.isCustom) {
                isPase = false;
                if (el.pathValues.indexOf('>') > -1) {
                    parentFid = el.pathValues.split('>')[1].split(':')[0] * 1;
                    parentVid = el.pathValues.split('>')[1].split(':')[1] * 1;
                    for (var i = 0; i < attrVals.length; i++) {
                        if (attrVals[i].fid == parentFid && attrVals[i].vid == parentVid) {
                            // 由于纯在多个三级 多个二级的情况 所以 需要一级一级透传到顶层才知道是否是选中的值
                            // 下面是构造二级的下拉值
                            el.inputType = 1;
                            el.pathValues = el.pathValues.split('>')[0];
                            el.fid = parentFid;
                            el.vid = parentVid;
                            // 递归验证
                            const checkParent = this.checkParentAttr(attrVals, el);
                            if (checkParent) {
                                isPase = true;
                            } else {
                                isPase = false;
                            }
                            break;
                        }
                    }
                } else {
                    parentFid = el.pathValues.split(':')[0] * 1;
                    parentVid = el.pathValues.split(':')[1] * 1;
                    for (let i = 0; i < attrVals.length; i++) {
                        if (attrVals[i].fid == parentFid && attrVals[i].vid == parentVid) {
                            isPase = true;
                            break;
                        }
                    }
                }
            }
            return isPase;
        },
        getAttr() {
            // 获取属性
            const that = this;
            const ajaxData = {};
            if (this.attrData.ClassifyId == -1) {
                return;
            }
            ajaxData.categoryId = this.attrData.ClassifyId;
            ajaxData.isNeedFront = true;
            ajaxData.isGetCategoryType = true;
            this.$ajax.post('app/alicate/attr', ajaxData).then((data) => {
                // that.$loading().close();
                if (data.AttrVals == null) {
                    this.message = '属性接口请求失败';
                    return;
                }
                this.attrData.categoryType = data.CategoryType;
                this.handleAttr(data.AttrVals, (item) => {
                    if (item.inputType == 2 || item.inputType == 4) {
                        item.value = [];
                        item.vid = [];
                    }
                });
                if (that.attrData.initAttrVals.length > 0) {
                    // 初始化带有默认值的属性
                    const valAttr = that.attrData.initAttrVals; // 修改的产品属性
                    const dataAttrLen = data.AttrVals.length;
                    for (var g = 0; g < valAttr.length; g++) {
                        if (!valAttr[g].isCustom) {
                            // 非自定义的
                            for (var x = 0; x < dataAttrLen; x++) {
                                // 类目属性无值
                                // 在fid相同的情况 有可能是多个相同二级 多个相同三级 所以还需要验证父级别是否选中
                                if (valAttr[g].attributeID == data.AttrVals[x].fid) {
                                    if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                        if (data.AttrVals[x].value == '') {
                                            data.AttrVals[x].value = [];
                                        }
                                        const isSome = data.AttrVals[x].value.some((item) => {
                                            return item == valAttr[g].value;
                                        });
                                        if (!isSome) {
                                            data.AttrVals[x].value.push(valAttr[g].value);
                                        }
                                    } else {
                                        data.AttrVals[x].value =
                                            data.AttrVals[x].value != ''
                                                ? data.AttrVals[x].value + '、' + valAttr[g].value
                                                : valAttr[g].value;
                                    }
                                    var isOther = data.AttrVals[x].featureIdValues.length > 0;
                                    for (var p = 0; p < data.AttrVals[x].featureIdValues.length; p++) {
                                        if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                            if (data.AttrVals[x].vid == '') {
                                                data.AttrVals[x].vid = [];
                                            }
                                            if (data.AttrVals[x].featureIdValues[p].value == valAttr[g].value) {
                                                const isSome = data.AttrVals[x].vid.some((item) => {
                                                    return item == data.AttrVals[x].featureIdValues[p].vid;
                                                });
                                                if (!isSome) {
                                                    data.AttrVals[x].vid.push(data.AttrVals[x].featureIdValues[p].vid);
                                                }
                                                isOther = false;
                                                break;
                                            }
                                        } else {
                                            isOther = false;
                                            if (data.AttrVals[x].featureIdValues[p].value == valAttr[g].value) {
                                                data.AttrVals[x].vid = data.AttrVals[x].featureIdValues[p].vid;
                                                break;
                                            }
                                        }
                                    }
                                    if (isOther) {
                                        if (data.AttrVals[x].vid.indexOf(20213) <= -1) {
                                            if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                                if (data.AttrVals[x].value.length > 0) {
                                                    data.AttrVals[x].value.splice(data.AttrVals[x].value.length - 1, 1);
                                                }
                                                if (data.AttrVals[x].vid == '') {
                                                    data.AttrVals[x].vid = [];
                                                }
                                                data.AttrVals[x].vid.push(20213);
                                                data.AttrVals[x].value.push(valAttr[g].value);
                                            } else {
                                                data.AttrVals[x].vid = 20213;
                                                data.AttrVals[x].value = valAttr[g].value;
                                            }
                                        }
                                    }

                                    if (data.AttrVals[x].vid == '') {
                                        // 有些属性是写在其他里面，它的vid是20213,需要做特殊处理
                                        // if (
                                        //   data.AttrVals[x].inputType == 1 &&
                                        //   JSON.stringify(data.AttrVals[x].featureIdValues).indexOf(
                                        //     '{"vid":20213,"value":"其他"}'
                                        //   ) <= -1
                                        // ) {
                                        //   data.AttrVals[x].featureIdValues.push({
                                        //     value: "其他",
                                        //     vid: 20213,
                                        //   });
                                        // }
                                        data.AttrVals[x].value = valAttr[g].value;
                                        data.AttrVals[x].vid = 20213;
                                    }
                                }
                            }
                        } else {
                            // if (data.AttrVals.find((o) => o.fid === valAttr[g].attributeID)) {
                            var addAttr = {
                                defaultVaule: '',
                                defaultVid: '',
                                featureIdValues: [],
                                featureType: '0;',
                                fid: '',
                                fieldType: 'string',
                                inputType: 0,
                                isNeeded: 'N',
                                isSpecAttr: false,
                                isSpecPicAttr: false,
                                name: '',
                                pathValues: '',
                                subtree: [],
                                unit: '',
                                value: '',
                                vid: '',
                                isCustom: true,
                            };
                            addAttr.fid = 'divFid' + parseInt(Math.random() * 1000000);
                            addAttr.name = valAttr[g].attributeName;
                            addAttr.value = valAttr[g].value;
                            data.AttrVals.push(JSON.parse(JSON.stringify(addAttr)));
                        }
                    }
                    // }
                    // 可能通过上面把相同的属性都赋值了 这一步要过滤掉
                    const newDataAttrLen = data.AttrVals;
                    for (var n = 0; n < newDataAttrLen.length; n++) {
                        if (!that.checkParentAttr(data.AttrVals, data.AttrVals[n])) {
                            data.AttrVals[n].value = '';
                            data.AttrVals[n].vid = '';
                            continue;
                        }
                    }
                    // console.log(data);
                    Object.assign(options, JSON.parse(JSON.stringify(data)));
                    that.tree = this.getStreeStr(data.AttrVals);
                } else {
                    // 没有默认值的属性
                    Object.assign(options, JSON.parse(JSON.stringify(data)));
                    const onlyFirstPat = [];
                    // 筛选出第一级的属性
                    for (var j = 0; j < data.AttrVals.length; j++) {
                        if (data.AttrVals[j].pathValues == '') {
                            onlyFirstPat.push(data.AttrVals[j]);
                        }
                    }
                    that.tree = onlyFirstPat;
                }
                this.message = '';
                this.$emit('getTree', this.tree);
            });
        },
        getStreeStr(array) {
            var _array = [];
            Array.prototype.push.apply(_array, array); // 合并数组
            // 构造三级树形

            for (var z = 0; z < _array.length; z++) {
                if (_array[z].pathValues != '') {
                    // 排除掉第一级的对象
                    var _tPathValues = _array[z].pathValues;
                    if (_tPathValues.split('>').length > 1) {
                        // 三级菜单的格式是xxx:xxx>xxx:xxx

                        var _sFid = _tPathValues.split('>')[1].split(':')[0];
                        var _sVid = _tPathValues.split('>')[1].split(':')[1];
                        for (var g = 0; g < _array.length; g++) {
                            if (
                                _array[g].fid == _sFid &&
                                _array[g].vid == _sVid &&
                                _tPathValues.split('>')[0] == _array[g].pathValues
                            ) {
                                _array[g].subtree.push(_array[z]);
                            }
                        }
                    }
                }
            }
            // 构造二级树形
            for (var i = 0; i < _array.length; i++) {
                if (_array[i].pathValues == '') {
                    // 为空才是一级对象
                    const _fid = _array[i].fid;
                    const _value = _array[i].vid;
                    const _pathValues = _fid + ':' + _value;
                    for (var j = 0; j < _array.length; j++) {
                        if (_array[j] != '') {
                            // 不为空才是子集对象
                            if (_array[j].pathValues == _pathValues) {
                                // 该对象的二级菜单 二级菜单格式是xxx:xxx
                                _array[i].subtree.push(_array[j]);
                            }
                        }
                    }
                }
            }
            var errorArray = [];
            for (let j = 0; j < _array.length; j++) {
                if (_array[j].pathValues != '') {
                    errorArray.push(j);
                }
            }
            for (var x = errorArray.length - 1; x >= 0; x--) {
                // 删除多余节点
                _array.splice(errorArray[x], 1);
            }
            const currArray = JSON.parse(JSON.stringify(_array));
            this.filterPathValues(currArray);
            return currArray;
        },
        filterPathValues(currArray) {
            if (callBack) {
                const pathValues = [];
                for (var sk = 0; sk < currArray.length; sk++) {
                    if (currArray[sk].inputType == 1 && currArray[sk].vid) {
                        const parentPath = currArray[sk].fid + ':' + currArray[sk].vid;
                        pathValues.push(parentPath);
                        for (var sk1 = 0; sk1 < currArray[sk].subtree.length; sk1++) {
                            if (currArray[sk].subtree[sk1].inputType == 1 && currArray[sk].subtree[sk1].vid) {
                                pathValues.push(
                                    parentPath +
                                        '>' +
                                        currArray[sk].subtree[sk1].fid +
                                        ':' +
                                        currArray[sk].subtree[sk1].vid
                                );
                            }
                        }
                    }
                }
                callBack && callBack(pathValues);
            }
        },
        initModel(data) {
            // this.$loading({
            //   lock: true,
            //   text: "正在加载数据...",
            //   spinner: "el-icon-loading",
            //   background: "rgba(255,255,255,0)",
            // });
            this.init();
            const options = {
                CategoryType: null,
                LevelTitle: '',
                ClassifyId: -1,
                AttrVals: [],
                initAttrVals: [], // 初始化的数据
                callBack: undefined, // 回调
            };
            Object.assign(options, data);
            options.initAttrVals = options.initAttrVals.filter((o) => !!o.value);
            callBack = options.callBack;
            this.attrData.LevelTitle = options.LevelTitle;
            this.attrData.ClassifyId = options.ClassifyId;
            this.attrData.categoryType = options.CategoryType;
            this.handleAttr(options.AttrVals);
            this.attrData.AttrVals = JSON.parse(JSON.stringify(options.AttrVals));
            this.attrData.initAttrVals = JSON.parse(JSON.stringify(options.initAttrVals));
            if (this.attrData.AttrVals.length > 0) {
                this.initAttr();
            } else {
                this.getAttr();
            }
        },
        handleAttr(attrs = [], fn) {
            attrs.forEach((attr) => {
                if (attr.inputType == 1) {
                    if (attr.featureIdValues.length) {
                        const other = attr.featureIdValues.find((o) => o.value === '其他');
                        if (!other) {
                            attr.featureIdValues.push({
                                vid: 20213,
                                value: '其他',
                            });
                        } else {
                            other.vid = 20213;
                        }
                    } else {
                        attr.inputType = 0;
                    }
                }
                if (fn) {
                    fn(attr);
                }
            });
        },
        endueWithAttr(attrData) {
            // 获取属性
            this.init();
            const options = {
                CategoryType: null,
                LevelTitle: '',
                ClassifyId: -1,
                AttrVals: [],
                initAttrVals: [], // 初始化的数据
                callBack: undefined, // 回调
                callBack2: undefined, // 回调
                listIndex: 0,
            };
            Object.assign(options, attrData);
            callBack = options.callBack;
            callBack2 = options.callBack2;
            this.attrData.LevelTitle = options.LevelTitle;
            this.attrData.ClassifyId = options.ClassifyId;
            this.attrData.AttrVals = options.AttrVals;
            this.attrData.initAttrVals = options.initAttrVals;
            this.attrData.categoryType = options.CategoryType;
            const that = this;

            if (this.attrData.ClassifyId == -1) {
                return;
            }
            const data = JSON.parse(JSON.stringify(this.attrData));
            if (data.AttrVals == null) {
                return;
            }
            data.AttrVals.forEach((item) => {
                if (item.inputType == 2 || item.inputType == 4) {
                    item.value = [];
                    item.vid = [];
                }
            });
            if (that.attrData.initAttrVals.length > 0) {
                // 初始化带有默认值的属性
                const valAttr = that.attrData.initAttrVals; // 修改的产品属性
                const dataAttrLen = data.AttrVals.length;
                for (var g = 0; g < valAttr.length; g++) {
                    if (!valAttr[g].isCustom) {
                        // 非自定义的
                        for (var x = 0; x < dataAttrLen; x++) {
                            // 类目属性无值
                            // 在fid相同的情况 有可能是多个相同二级 多个相同三级 所以还需要验证父级别是否选中
                            if (valAttr[g].attributeID == data.AttrVals[x].fid) {
                                if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                    if (data.AttrVals[x].value == '') {
                                        data.AttrVals[x].value = [];
                                    }
                                    const isSome = data.AttrVals[x].value.some((item) => {
                                        return item == valAttr[g].value;
                                    });
                                    if (!isSome) {
                                        data.AttrVals[x].value.push(valAttr[g].value);
                                    }
                                } else {
                                    data.AttrVals[x].value =
                                        data.AttrVals[x].value != ''
                                            ? data.AttrVals[x].value + '、' + valAttr[g].value
                                            : valAttr[g].value;
                                }
                                var isOther = data.AttrVals[x].featureIdValues.length > 0;
                                for (var p = 0; p < data.AttrVals[x].featureIdValues.length; p++) {
                                    if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                        if (data.AttrVals[x].vid == '') {
                                            data.AttrVals[x].vid = [];
                                        }
                                        if (data.AttrVals[x].featureIdValues[p].value == valAttr[g].value) {
                                            const isSome = data.AttrVals[x].vid.some((item) => {
                                                return item == data.AttrVals[x].featureIdValues[p].vid;
                                            });
                                            if (!isSome) {
                                                data.AttrVals[x].vid.push(data.AttrVals[x].featureIdValues[p].vid);
                                            }
                                            isOther = false;
                                            break;
                                        }
                                    } else {
                                        isOther = false;
                                        if (data.AttrVals[x].featureIdValues[p].value == valAttr[g].value) {
                                            data.AttrVals[x].vid = data.AttrVals[x].featureIdValues[p].vid;
                                            break;
                                        }
                                    }
                                }
                                if (isOther) {
                                    if (data.AttrVals[x].vid.indexOf(20213) <= -1) {
                                        if (data.AttrVals[x].inputType == 2 || data.AttrVals[x].inputType == 4) {
                                            if (data.AttrVals[x].value.length > 0) {
                                                data.AttrVals[x].value.splice(data.AttrVals[x].value.length - 1, 1);
                                            }
                                            if (data.AttrVals[x].vid == '') {
                                                data.AttrVals[x].vid = [];
                                            }
                                            data.AttrVals[x].vid.push(20213);
                                            data.AttrVals[x].value.push(valAttr[g].value);
                                        } else {
                                            data.AttrVals[x].vid = 20213;
                                            data.AttrVals[x].value = valAttr[g].value;
                                        }
                                    }
                                }

                                if (data.AttrVals[x].vid == '') {
                                    // 有些属性是写在其他里面，它的vid是20213,需要做特殊处理
                                    // if (
                                    //   data.AttrVals[x].inputType == 1 &&
                                    //   JSON.stringify(data.AttrVals[x].featureIdValues).indexOf(
                                    //     '{"vid":20213,"value":"其他"}'
                                    //   ) <= -1
                                    // ) {
                                    //   data.AttrVals[x].featureIdValues.push({
                                    //     value: "其他",
                                    //     vid: 20213,
                                    //   });
                                    // }
                                    data.AttrVals[x].value = valAttr[g].value;
                                    data.AttrVals[x].vid = 20213;
                                }
                            }
                        }
                    } else {
                        var addAttr = {
                            defaultVaule: '',
                            defaultVid: '',
                            featureIdValues: [],
                            featureType: '0;',
                            fid: '',
                            fieldType: 'string',
                            inputType: 0,
                            isNeeded: 'N',
                            isSpecAttr: false,
                            isSpecPicAttr: false,
                            name: '',
                            pathValues: '',
                            subtree: [],
                            unit: '',
                            value: '',
                            vid: '',
                            isCustom: true,
                        };
                        addAttr.fid = 'divFid' + parseInt(Math.random() * 1000000);
                        addAttr.name = valAttr[g].attributeName;
                        addAttr.value = valAttr[g].value;
                        data.AttrVals.push(JSON.parse(JSON.stringify(addAttr)));
                    }
                }
                // 可能通过上面把相同的属性都赋值了 这一步要过滤掉
                const newDataAttrLen = data.AttrVals;
                for (var n = 0; n < newDataAttrLen.length; n++) {
                    if (!that.checkParentAttr(data.AttrVals, data.AttrVals[n])) {
                        data.AttrVals[n].value = '';
                        data.AttrVals[n].vid = '';
                        continue;
                    }
                }
                // console.log(data);
                Object.assign(options, JSON.parse(JSON.stringify(data)));
                that.tree = this.getStreeStr(data.AttrVals);
            } else {
                // 没有默认值的属性
                Object.assign(options, JSON.parse(JSON.stringify(data)));
                const onlyFirstPat = [];
                // 筛选出第一级的属性
                for (var j = 0; j < data.AttrVals.length; j++) {
                    if (data.AttrVals[j].pathValues == '') {
                        onlyFirstPat.push(data.AttrVals[j]);
                    }
                }
                that.tree = onlyFirstPat;
            }
            callBack2 && callBack2(that.tree, options.listIndex, options);
            // this.$emit('tsGetTree', this.tree)
        },
        tsSubTree(el) {
            this.setValue(el);
            this.getSubtree(el);
            // this.selectCallBack(el)
            const _pathValues = [];
            if (el.pathValues == '') {
                // 一级下拉值
                _pathValues.push(el.fid + ':' + el.vid);
            } else if (el.pathValues.indexOf('>') <= -1) {
                // 二级下拉值
                _pathValues.push(el.pathValues + '>' + el.fid + ':' + el.vid);
            }
            return this.tree;
        },
    },
};
</script>
<style lang="scss" scoped>
.attribute {
    height: 100%;
    background: white;
    padding: 10px 0;
    /*overflow: auto;*/
}
.message {
    display: flex;
    align-items: center;
    justify-content: center;
    color: orange;
    font-size: 12px;
}
</style>
